// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/swiper/dist/css/swiper.min.css
// module id = 1437
// module chunks = 10 21